











import { Component, Vue } from "vue-property-decorator";
import { CTabPageList } from "../types";

@Component
export default class RTab extends Vue {
  private mounted() {
    if (typeof this.$route.name === "string") {
      const routeName = this.$route.name;
      if (CTabPageList.COrders.includes(routeName)) {
        (this.$refs.COrders as Vue).$el.className = `${(this.$refs.COrders as Vue).$el.className} is-current`;
      }
      if (CTabPageList.CUserProfile.includes(routeName)) {
        (this.$refs.CUserProfile as Vue).$el.className = `${(this.$refs.CUserProfile as Vue).$el.className} is-current`;
      }
    }
  }
}
